<script setup lang="ts">
defineProps<{
  label: string
  count: number
  showAll?: boolean
}>()

const emit = defineEmits<{ showAll: [] }>()
</script>

<template>
  <div class="px-3 pt-3 pb-1 flex items-center justify-between">
    <span class="text-xs font-semibold uppercase tracking-wider text-base-content/50">
      {{ label }}
      <span class="ml-1 text-base-content/30 normal-case tracking-normal font-normal">{{ count }}</span>
    </span>
    <button
      v-if="showAll"
      class="text-xs text-primary hover:underline"
      @click="emit('showAll')"
    >
      Voir tout
    </button>
  </div>
</template>
